<script setup lang="ts">
import type { BlogT } from '~/schema/types'

defineProps<{
  blog: BlogT
}>()
</script>

<template>
  <UiCardFeature
    :key="blog.slug"
    class="hover:bg-surface-container-high"
    wrapper-class="p-0 gap-0 overflow-hidden"
  >
    <NuxtImg
      v-if="blog.image"
      :src="blog.image"
      class="object-content w-full img aspect-video"
      :alt="blog.image_alt ?? undefined"
      loading="lazy"
    />
    <div class="flex flex-col justify-between grow p-3.5">
      <h2
        class="font-display font-bold group-hover:text-primary line-clamp-2 mb-2 title"
      >
        {{ blog.title }}
      </h2>
      <div class="w-full flex left-0 right-0">
        <div
          class="flex flex-wrap items-center gap-x-1 text-xs text-on-surface-variant"
        >
          <span class="author">
            {{ blog?.user?.name ?? '-' }}
          </span>
          <span>•</span>
          <span>
            {{ formatDateShortMonth(blog.published_at) }}
          </span>
          <template v-if="blog.category?.name">
            <span>•</span>
            <span class="text-primary category">
              {{ blog.category?.name }}
            </span>
          </template>
        </div>
      </div>
    </div>
    <NuxtLink
      prefetch
      :to="`/blog/${blog.slug}`"
      :aria-label="blog.title ?? 'Blog Title'"
      class="absolute inset-0 z-10"
    />
  </UiCardFeature>
</template>
